import type { Replace } from 'type-fest';
import { z } from 'zod';

export function mapAPIListErrorsToFormListErrors<const T extends string>(key: T, path: string) {
  // Strip off any properties from server, we only care about the index
  const fieldPath = z
    .string()
    .refine(
      (x): x is `${T}[${number}]` => new RegExp(`${key}\\[\\d+\\]`).test(x),
      (val) => ({ message: `Expected ${val} to match '${key}[number] format. The full original path was ${path}` })
    )
    .parse(path.split('.')[0]);

  // Type shenanigans w/ type-fest to snake the string type through.
  const one = fieldPath.replace('[', '.') as Replace<typeof fieldPath, '[', '.'>;
  const mappedFieldPath = one.replace(']', '') as Replace<typeof one, ']', ''>;

  return mappedFieldPath;
}
